import React from 'react';
import { payoutWinToProb } from '../../helpers/';

const Risk = ({payout}) => {
    let winProb = payoutWinToProb(payout.num);
    let n = parseFloat(winProb);
    let risk = (n * 100).toFixed(2);
    return (
        <div>
            <span id="label"> RISK </span>
            <div> { risk.toString() } </div>
        </div>
    )
}

export default Risk;


// WEBPACK FOOTER //
// ./src/components/bet/Risk.js